import { useMemo, useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import { useDimensions } from '../scene/useDimensions'
import { useSelectedValueByVariableKey } from '@k3/core'
import { Keys } from '../utility/utils'

const scale = [0.01, 0.01, 0.01]

function getPosition(
  borderWidth: number,
  length: number,
  width: number,
  position: string
) {
  const borderOffset = borderWidth + 0.05

  const getAsidePos = () => {
    const positionRight = [0, length - borderOffset, 0]
    const positionLeft = [width, length - borderOffset, 0]
    const rotationRight = [0, Math.PI, 0]
    const rotationLeft = [0, 0, 0]
    return { positionRight, positionLeft, rotationLeft, rotationRight }
  }

  const getTopPos = () => {
    const positionRight = [borderOffset, length, 0]
    const positionLeft = [width - borderOffset, length, 0]
    const rotationRight = [0, 0, Math.PI / 2]
    const rotationLeft = [0, Math.PI, Math.PI / 2]
    return { positionRight, positionLeft, rotationLeft, rotationRight }
  }

  const getAsideFlippedPos = () => {
    const positionRight = [borderOffset, 0, 0]
    const positionLeft = [borderOffset, length, 0]
    const rotationRight = [0, Math.PI, -Math.PI / 2]
    const rotationLeft = [0, 0, Math.PI / 2]
    return { positionRight, positionLeft, rotationLeft, rotationRight }
  }

  const getTopFlippedPos = () => {
    const positionRight = [0, borderOffset, 0]
    const positionLeft = [0, length - borderOffset, 0]
    const rotationRight = [0, 0, Math.PI]
    const rotationLeft = [0, Math.PI, 0]
    return { positionRight, positionLeft, rotationLeft, rotationRight }
  }

  if (length < width) {
    return position === Keys.ClearConnectorPosition.Value.Aside
      ? getAsideFlippedPos()
      : getTopFlippedPos()
  } else {
    return position === Keys.ClearConnectorPosition.Value.Aside
      ? getAsidePos()
      : getTopPos()
  }
}

export const Connect7 = () => {
  const group: any = useRef()

  const position =
    useSelectedValueByVariableKey(Keys.ClearConnectorPosition.Variable)?.key ??
    Keys.ClearConnectorPosition.Default

  const { length, width, borderWidth } = useDimensions()
  let { positionRight, positionLeft, rotationLeft, rotationRight } =
    getPosition(borderWidth, length, width, position)

  const { nodes } = useGLTF(`models/RandanschlussConnect7.glb`) as GLTF & any

  const RandanschlussConnect7Left = useMemo(
    () => nodes.RandanschlussConnect7.clone(),
    [nodes]
  )

  return (
    <group ref={group}>
      <primitive
        object={nodes.RandanschlussConnect7}
        scale={scale}
        position={positionRight}
        rotation={rotationRight}
      />

      <primitive
        object={RandanschlussConnect7Left}
        scale={scale}
        position={positionLeft}
        rotation={rotationLeft}
      />
    </group>
  )
}
